import mdcList from './mdc-list.vue'
import mdcListItem from './mdc-list-item.vue'
import mdcListItemText from './mdc-list-item-text.vue'
import mdcListItemGraphic from './mdc-list-item-graphic.vue'
import mdcListDivider from './mdc-list-divider.vue'
export const mdcListComponents = {
  mdcList,
  mdcListItem,
  mdcListItemText,
  mdcListItemGraphic,
  mdcListDivider,
}